<div class="flex max-h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start justify-between bg-primary-50 px-6 py-4 dark:bg-primary-900/10">
    <div class="flex items-start gap-2">
      <mat-icon class="text-primary mt-0.5" fontSet="material-icons-outlined">inventory_2</mat-icon>
      <div>
        <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.TITLE' | t }}</h2>
        <div class="text-primary font-bold">{{ item.code ? item.code + ' - ' + item.name : item.name }}</div>
      </div>
    </div>
    <button mat-icon-button type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- body -->
  <div class="min-h-0 flex-1 overflow-auto px-6 py-5">
    <!-- notas -->
    <div class="mb-2 flex items-center gap-2">
      <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">sticky_note_2</mat-icon>
      <h3 class="font-semibold">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.NOTES_SECTION' | t }}</h3>
    </div>
    <div class="mb-6 flex flex-col gap-1">
      <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.NOTES_LABEL' | t }}</span>
      <textarea
        [formControl]="noteControl"
        rows="4"
        maxlength="500"
        [placeholder]="'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.NOTES_PLACEHOLDER' | t"
        class="w-full rounded-lg border px-3 py-2 text-sm outline-none dark:bg-transparent"></textarea>
      <span class="text-secondary self-end text-xs">{{ (noteControl.value?.length || 0) }} / 500</span>
    </div>

    <!-- adjuntos -->
    <div class="mb-2 flex items-center gap-2">
      <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">attach_file</mat-icon>
      <h3 class="font-semibold">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.ATTACHMENTS_SECTION' | t }}</h3>
    </div>
    <div class="mb-6 flex flex-col gap-3">
      @if (!readonly) {
      <app-attachment-input class="dg-uploader-only" [config]="attachmentConfig" [formControl]="attachmentsControl"></app-attachment-input>
      <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.MAX_FILES' | t: { max: MAX_ATTACHMENTS } }}</span>
      }

      <!-- evidencias ya subidas -->
      @for (file of evidences; track file.link; let i = $index) {
      <div class="flex items-center gap-2 rounded-lg border bg-gray-50 px-3 py-2 dark:bg-transparent">
        <mat-icon class="text-secondary icon-size-5 shrink-0">insert_drive_file</mat-icon>
        <div class="flex min-w-0 flex-1 flex-col">
          <span class="truncate text-sm font-medium" [matTooltip]="file.mobileName || file.name || ''">{{ file.mobileName || file.name || ('DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.ATTACHMENT_FALLBACK' | t) }}</span>
        </div>
        <button mat-icon-button color="primary" type="button" class="shrink-0" [matTooltip]="'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.VIEW' | t" (click)="openEvidence(file)">
          <mat-icon class="icon-size-5" fontSet="material-icons-outlined">visibility</mat-icon>
        </button>
        @if (!readonly) {
        <button mat-icon-button color="warn" type="button" class="shrink-0" [matTooltip]="'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.REMOVE' | t" (click)="removeEvidence(i)">
          <mat-icon>close</mat-icon>
        </button>
        }
      </div>
      }

      <!-- adjuntos nuevos (aún no subidos) -->
      @for (file of newFiles; track file.name; let i = $index) {
      <div class="flex items-center gap-2 rounded-lg border bg-gray-50 px-3 py-2 dark:bg-transparent">
        <mat-icon class="text-secondary icon-size-5 shrink-0">insert_drive_file</mat-icon>
        <div class="flex min-w-0 flex-1 flex-col">
          <span class="truncate text-sm font-medium" [matTooltip]="file.name">{{ file.name }}</span>
          <span class="text-secondary text-xs">{{ formatFileSize(file.size) }}</span>
        </div>
        <button mat-icon-button color="primary" type="button" class="shrink-0" [matTooltip]="'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.VIEW' | t" (click)="openNewFile(file)">
          <mat-icon class="icon-size-5" fontSet="material-icons-outlined">visibility</mat-icon>
        </button>
        @if (!readonly) {
        <button mat-icon-button color="warn" type="button" class="shrink-0" [matTooltip]="'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.REMOVE' | t" (click)="removeNewFile(i)">
          <mat-icon>close</mat-icon>
        </button>
        }
      </div>
      }

      @if (readonly && !evidences.length && !newFiles.length) {
      <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.NO_ATTACHMENTS' | t }}</span>
      }
    </div>

    <!-- stock por almacén -->
    @if (data.showStock) {
    <div class="mb-2 flex items-center gap-2">
      <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">warehouse</mat-icon>
      <h3 class="font-semibold">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.STOCK_SECTION' | t }}</h3>
    </div>
    <div class="rounded-xl border">
      @if (stockLoading) {
      <div class="text-secondary px-4 py-6 text-center text-sm">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.STOCK_LOADING' | t }}</div>
      } @else if (!stockRows.length) {
      <div class="text-secondary px-4 py-6 text-center text-sm">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.STOCK_EMPTY' | t }}</div>
      } @else {
      <div class="overflow-x-auto">
      <table class="w-full min-w-[520px] border-collapse text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800">
          <tr class="text-secondary text-left">
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.COLUMN_CODE' | t }}</th>
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.FIELDS.WAREHOUSE' | t }}</th>
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_FALLBACK' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.COLUMN_AVAILABLE' | t }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of stockRows; track row.warehouseCode) {
          <tr class="border-t">
            <td class="px-4 py-3 font-semibold">{{ row.warehouseCode }}</td>
            <td class="px-4 py-3">{{ row.warehouseName }}</td>
            <td class="px-4 py-3">{{ row.unitLabel }}</td>
            <td class="px-4 py-3 text-right" [class.text-red-600]="row.availableStock === 0">{{ row.availableStock | dgNumber:'stock' }}</td>
          </tr>
          }
        </tbody>
      </table>
      </div>
      }
    </div>
    }
  </div>

  <!-- footer -->
  <div class="flex items-center justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
    <button mat-stroked-button type="button" (click)="close()">{{ (readonly ? 'GENERAL.CLOSE' : 'GENERAL.CANCEL') | t }}</button>
    @if (!readonly) {
    <button mat-flat-button color="primary" type="button" (click)="save()">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.SAVE' | t }}</button>
    }
  </div>
</div>
